import React from "react";
import RefferalsOptyCountGraph from "../Graphs/BarGraph/RefferalsOptyCountGraph";
import RefferalsDataGraph from "../Graphs/BarGraph/RefferalsDataGraph";

const Refferals = ({ refferalsDataGraph, refferalsOptyGraph }) => {
  // Filter out empty objects and ensure valid data
  const dataGraph = Array.isArray(refferalsDataGraph) 
    ? refferalsDataGraph.filter(item => item && typeof item === 'object' && Object.keys(item).length > 0)
    : [];
  
  const optyGraph = Array.isArray(refferalsOptyGraph) 
    ? refferalsOptyGraph.filter(item => item && typeof item === 'object' && Object.keys(item).length > 0)
    : [];

  return (
    <div className="flex gap-4">
      <RefferalsDataGraph refferalsDataGraph={dataGraph} />
      <RefferalsOptyCountGraph
        refferalsOptyGraph={optyGraph}
        refferalsDataGraph={dataGraph}
      />
    </div>
  );
};

export default Refferals;